import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/modify';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';

class ModifyUser extends React.Component {

  render() {
    const {
      t,
      userName,
      firstName,
      lastName,
      active,
      onUserName,
      onFirstName,
      onLastName,
      onActive,
      disabled,
      onSave,
      onCancel,
      canSave,
      onChangePassword
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value: value || '',
      onChange: (event) => fn(event.target.value)
    });
    return (
      <div className={classes.container}>
        <div>
          <div>
            <FormGroup>
              <Label for="modify_userName">{t('modify.userNameLabel')}</Label>
              <Input
                name="modify_userName"
                id="modify_userName"
                placeholder={t('modify.userNamePlaceholder')}
                disabled={disabled}
                {...getFieldProps(userName, onUserName)}
              />
            </FormGroup>
          </div>
          <div>
            <FormGroup>
              <Label for="modify_firstName">{t('modify.firstNameLabel')}</Label>
              <Input
                name="modify_firstName"
                id="modify_firstName"
                placeholder={t('modify.firstNamePlaceholder')}
                disabled={disabled}
                {...getFieldProps(firstName, onFirstName)}
              />
            </FormGroup>
          </div>
          <div>
            <FormGroup>
              <Label for="modify_lastName">{t('modify.lastNameLabel')}</Label>
              <Input
                name="modify_lastName"
                id="modify_lastName"
                placeholder={t('modify.lastNamePlaceholder')}
                disabled={disabled}
                {...getFieldProps(lastName, onLastName)}
              />
            </FormGroup>
          </div>
          <div>
            <FormGroup check>
              <Label for="modify_active" check>
                <Input
                  type="checkbox"
                  name="modify_active"
                  id="modify_active"
                  disabled={disabled}
                  checked={(active || false).toString() === 'true'}
                  onChange={event => onActive(event.target.checked)}
                />
                {t('modify.activeLabel')}
              </Label>
            </FormGroup>
          </div>
          <div style={{ paddingTop: 15 }}>
            <FormGroup>
              <Button
                size="sm"
                disabled={disabled}
                onClick={onChangePassword}
                style={{ width: '100%' }}
              >
                {t('modify.changePasswordAction')}
              </Button>
            </FormGroup>
          </div>
        </div>
        <div className={classes.actionsContainer}>
          <Button
            color="primary"
            size="sm"
            disabled={!canSave || disabled}
            onClick={onSave}
          >
            {t('modify.saveAction')}
          </Button>
          <Button
            color="danger"
            size="sm"
            disabled={disabled}
            onClick={onCancel}
          >
            {t('modify.cancelAction')}
          </Button>
        </div>
      </div>
    )
  }

}

ModifyUser.propTypes = {
  userName: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  active: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf([
      'true',
      'false'
    ])
  ]),
  onUserName: PropTypes.func.isRequired,
  onFirstName: PropTypes.func.isRequired,
  onLastName: PropTypes.func.isRequired,
  onActive: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  onChangePassword: PropTypes.func.isRequired
};

export default translate(['user'])(ModifyUser);


// WEBPACK FOOTER //
// ./src/views/user/modify.js